import React from "react";

/**
 * 导航组件
 *  leading  React.Node
 *  title React.Node
 *  actions React.Node[]
 */
export interface NavigationBarProps {
	leading?: React.ReactNode;
	title?: string;
	actions?: React.ReactNode[];
}

export default function NavigationBar(props: NavigationBarProps) {
	return (
		<div className="flex h-12 items-center">
			<div className="inline-flex min-w-[32px] flex-shrink-0">{props.leading && props.leading}</div>

			<div className="flex-1 truncate px-4 text-center text-sm font-semibold h-[24px] leading-[24px] -mt-[2px]">
				{props.title}
			</div>

			<div className="inline-flex min-w-[32px] flex-shrink-0 justify-end">
				{props.actions && props.actions.map((item) => item)}
			</div>
		</div>
	);
}
